import React from 'react';

const Ordering = (props: object) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="fi_3942703"
      data-name="Layer 2"
      viewBox="0 0 16 16"
      width="24"
      height="24"
      {...props}
    >
      <path d="M8,14a1.5017,1.5017,0,0,0,1.5,1.5h4A1.5017,1.5017,0,0,0,15,14V10a1.5017,1.5017,0,0,0-1.5-1.5h-4A1.5017,1.5017,0,0,0,8,10Zm1-4a.5.5,0,0,1,.5-.5h4a.5.5,0,0,1,.5.5v4a.5.5,0,0,1-.5.5h-4A.5.5,0,0,1,9,14Z"></path>
      <path d="M9.5,7.5h4A1.5017,1.5017,0,0,0,15,6V2A1.5017,1.5017,0,0,0,13.5.5h-4A1.5017,1.5017,0,0,0,8,2V6A1.5017,1.5017,0,0,0,9.5,7.5ZM9,2a.5.5,0,0,1,.5-.5h4A.5.5,0,0,1,14,2V6a.5.5,0,0,1-.5.5h-4A.5.5,0,0,1,9,6Z"></path>
      <path d="M3.5,4.5h3a.5.5,0,0,0,0-1h-3A2.503,2.503,0,0,0,1,6v4a2.503,2.503,0,0,0,2.5,2.5H5.293L4.1465,13.6465a.5.5,0,1,0,.707.707l1.9994-1.9994a.5016.5016,0,0,0,0-.7082L4.8535,9.6465a.5.5,0,0,0-.707.707L5.293,11.5H3.5A1.5017,1.5017,0,0,1,2,10V6A1.5017,1.5017,0,0,1,3.5,4.5Z"></path>
    </svg>
  );
};

export default Ordering;
